<template>
  <div class="p-4 w-full text-center">
    <div v-if="generic">
      <h1 class="text-xl mb-2">Thank you for completing the survey.</h1>
      <div class="text-left">
        <p class="mb-3">Your average score was <b>{{calcAvg(avg)}}</b>. The current national average for Employee Confidence is <b>{{calcAvg(globalAvg)}}</b>.</p>
        <p>Your score out of 10 provides an indication of your confidence in your organisation’s potential for current and future success.</p>
      </div>
      <div class="py-4 mx-auto" style="max-width:200px">
        <mini-bar-chart :chartData="pieData" :options="pieOptions"></mini-bar-chart>
      </div>
      <div class="text-left mt-4">
        <p class="mb-3">The overall national average score will be updated here in real time, so check back here to see how your Confidence as an employee compares to the rest of the country’s employees participating in this survey process.</p>
      </div>
      <div class="text-left mt-8">
        <h2 class="text-sm">CONFIDENTIALITY</h2>
        <p class="text-sm text-grey-darker">K3 Consulting will not disclose your information to any party outside of this process. The information you provide will be stored securely by K3 Consulting with appropriately restricted access. By completing this survey and submitting it you are acknowledging and agreeing that you are supplying personal information for the purposes of creating an Employee Confidence benchmark and these results can be released to K3 Consulting Ltd for this purpose. For more information on K3’s Privacy Policy, go to: <a class="underline text-blue hover:text-blue-darker focus:text-blue-darker" target="_blank" href=" https://cdn2.hubspot.net/hubfs/3417663/Privacy%20and%20Confidentiality%20Policy%20-%20Employee%20Confidence%202020.pdf">Privacy & Confidentiality Policy 2020</a></p>
      </div>
      <div class="pt-8">
        <button class="mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold" @click="goNext" type="button" :style="{backgroundColor: brandColor}">Go Back</button>
      </div>
    </div>
    <div v-else>
      <h1 class="text-xl mb-2">Thank you for completing the survey.</h1>
      <div class="text-left">
        <p class="mb-3">Your average score was <b>{{calcAvg(avg)}}</b>. The current national average for Employee Confidence is <b>{{calcAvg(globalAvg)}}</b>.</p>
        <p>Your score out of 10 provides an indication of your confidence in your organisation’s potential for current and future success.</p>
      </div>
      <div class="py-4 mx-auto" style="max-width:200px">
        <mini-bar-chart :chartData="pieData" :options="pieOptions"></mini-bar-chart>
      </div>
      <div class="text-left mt-8">
        <h2 class="text-sm">CONFIDENTIALITY</h2>
        <p class="text-sm text-grey-darker">Your score will contribute to your organisation’s total average score. The organisation cannot see your individual results. K3 Consulting will not disclose your information to any party outside of this process. The information you provide will be stored securely by K3 Consulting with appropriately restricted access. By completing this survey and submitting it you are acknowledging and agreeing that you are supplying personal information for the purposes of creating an Employee Confidence benchmark and these results can be released to K3 Consulting Ltd for this purpose. For more information on K3’s Privacy Policy, go to: <a class="underline text-blue hover:text-blue-darker focus:text-blue-darker" target="_blank" href=" https://cdn2.hubspot.net/hubfs/3417663/Privacy%20and%20Confidentiality%20Policy%20-%20Employee%20Confidence%202020.pdf">Privacy & Confidentiality Policy 2020</a></p>
      </div>
      <!-- <div class="pt-8">
        <button class="mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold" @click="goNext" type="button" :style="{backgroundColor: brandColor}">Go Back</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import MiniBarChart from '@/components/charts/MiniBarChart'
import axios from 'axios'
export default {
  name: 'final',
  components: {MiniBarChart},
  props: ['brandColor'],
  created () {
    let obj = localStorage.getItem('user-data')
    let data = JSON.parse(obj)

    this.avg = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reduce((p, c) => data['ans_' + c] + p, 0) / 12
    if (localStorage.getItem('surveyType') !== 'generic') {
      this.img = this.getObj('company').logo
    }

    if (this.getObj('surveySubmit') === true) {
      this.surveySubmitted = true
    }
    let param = 'generic'
    if (localStorage.getItem('surveyType') !== 'generic') {
      param = this.getObj('company').link
      this.generic = false
      // param = this.$route.params.link
    }
    axios.get(`${process.env.APP_PATH}/survey/avg/${localStorage.getItem('surveyType')}/${param}`)
      .then(response => {
        this.globalAvg = response.data.avg
        localStorage.setItem('globalAvg', this.globalAvg)
      })
      .catch(e => {
        console.log(e)
      })
  },
  data () {
    return {
      img: '',
      avg: 0,
      globalAvg: 0,
      surveySubmitted: false,
      generic: true,
      pieOptions: {
        tooltips: {
          enabled: false
        },
        responsive: true,
        legend: {display: false},
        animation: {
          duration: 3000
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              max: 10
            }
          }]
        }
      }
    }
  },
  methods: {
    calcAvg (avg) {
      var surveyType = localStorage.getItem('surveyType')
      if (surveyType === 'customer') {
        return parseFloat((avg * 8).toFixed(2))
      } else {
        return parseFloat((avg).toFixed(2))
      }
    },
    getObj (name) {
      let obj = localStorage.getItem(name)
      return JSON.parse(obj)
    },
    backQuestion () {
      let param = {qno: 1}
      if (localStorage.getItem('surveyType') !== 'generic') {
        param = { link: this.$route.params.link, qno: 1 }
      }
      this.$router.push({name: 'question', params: param})
    },
    goNext () {
      var surveyType = localStorage.getItem('surveyType')
      var param = {link: this.$route.params.link}
      console.log(surveyType, param)
      localStorage.clear()
      if (surveyType === 'generic') {
        this.$router.push(`/generic`)
      } else if (surveyType === 'customer') {
        this.$router.push(`/customer/${param.link}`)
      } else {
        this.$router.push(`/survey/${param.link}`)
      }
    }
  },
  computed: {
    pieData () {
      var arr = {
        labels: ['You', 'National'],
        datasets: [{
          backgroundColor: ['#ef4a47', '#8f2c2b'],
          hoverBorderWidth: 0,
          data: [this.calcAvg(this.avg), this.calcAvg(this.globalAvg)]
        }]
      }
      return arr
    }
  }
}
</script>

<style>

.btn-class{
 display: inline-block;
 border:1px solid #c9ae34;
 color: #705D07;
 border-radius: 3px 3px 3px 3px;
 -webkit-border-radius: 3px 3px 3px 3px;
 -moz-border-radius: 3px 3px 3px 3px;
 font-family: Verdana;
 width: auto;
 height: auto;
 font-size: 16px;
 padding: 8px 36px;
 box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d,0 2px 4px 0 #D4D4D4;
 -moz-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d,0 2px 4px 0 #D4D4D4;
 -webkit-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d,0 2px 4px 0 #D4D4D4;
 text-shadow: 0 1px 0 #fff;
 background-image: linear-gradient(to top, #fce374, #fcdf5b);
 background-color: #fce374;
}
.btn-class:hover, .btn-class:active{
 border:1px solid #967d09;
 color: #705D07;
 box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d;
 -moz-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d;
 -webkit-box-shadow: inset 0 1px 0 0 #fff6ce,inset 0 -1px 0 0 #e3c852,inset 0 0 0 1px #fce88d;
 background-color: #fcdf5b;
}
</style>



// WEBPACK FOOTER //
// src/components/Final.vue